import { DESKTOP_MAX_INT } from './constants';

export const responsive = (width, base = DESKTOP_MAX_INT, neg = false) =>
  `calc(${width} / ${base} * ${neg ? '-' : ''}100%)`;
